const getElementInViewport = (el: HTMLElement): boolean => {
  if (!el) {
    console.warn('Element is null')
    return false
  }

  const rect = el.getBoundingClientRect()

  const viewportWidth   = window.innerWidth || document.documentElement.clientWidth
  const viewportHeight  = window.innerHeight || document.documentElement.clientHeight
  const isFitInViewport = el.offsetHeight < viewportHeight

  const isInAxisX = rect.left >= 0 && rect.right <= viewportWidth
  const isInAxisY = isFitInViewport ? (
    rect.top >= 0
    && rect.bottom <= viewportHeight
  ) : (
    rect.top <= 0
    && rect.bottom > 0
  )

  return isInAxisX && isInAxisY
}


export default getElementInViewport
